var _Path, _Path2, _Path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgHudInfo = function SvgHudInfo(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 16"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    stroke: "#9CB6D8",
    strokeWidth: 1.5,
    d: "M14.25 8a6.25 6.25 0 1 1-12.5 0 6.25 6.25 0 0 1 12.5 0Z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    stroke: "#9CB6D8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8 7.25V11"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    fill: "#9CB6D8",
    d: "M8 5.85a.95.95 0 1 0 0-1.9.95.95 0 0 0 0 1.9"
  })));
};
export default SvgHudInfo;